import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface CountAssignmentReferencesFromClasses extends AxiosRequestConfig {
  method: 'GET';
  url: `/work-folders/${string}/assignment-references/count`;
}

export interface KlassAssignmentsIndexByExerciseFolderResponse {
  count: number;
}

/**
 * GET /vo/v1/work-folders/${assignmentFolderId}/assignment-references/count
 */
export const countAssignmentReferencesFromClasses = (
  assignmentFolderId: string,
): CountAssignmentReferencesFromClasses => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/work-folders/${assignmentFolderId}/assignment-references/count`,
  } as const;
};
